import { createRouter, createWebHistory } from "vue-router";
import NotFound from "@/pages/NotFound";
import ErrorPage from "@/pages/ErrorPage";
import globals from "@/globals";
import Layout2 from "@/layout/Layout2";
import authGuard from "@/auth/authGuard";
import { getCurrentInstance } from "vue"; // Import getCurrentInstance for Vue 3

const routes = [
  {
    name: "emailVerified",
    path: "/emailVerified",
    component: () => import("@/pages/Users/Verified"),
    props: true,
    meta: { noAuthRequired: true }
  },
  {
    path: "/",
    component: Layout2,
    children: [
      {
        path: "",
        component: () => import("@/pages/Overview/Overview")
      },
      {
        path: "trends",
        component: () => import("@/pages/Trends/Trends")
      },
      {
        path: "sales",
        component: () => import("@/pages/Sales/Sales")
      },
      {
        path: "machines",
        component: () => import("@/pages/Machines/Machines")
      },
      {
        path: "machines/archived",
        component: () => import("@/pages/Machines/Archived")
      },
      {
        path: "machines/add",
        component: () => import("@/pages/Machines/Add")
      },
      {
        name: "machine",
        path: "machines/:id",
        props: true,
        component: () => import("@/pages/Machines/Machine"),
        children: [
          {
            name: "machineDetails",
            path: "",
            component: () => import("@/pages/Machines/MachineDetails"),
            props: true
          },
          {
            name: "machineInteractions",
            path: "interactions",
            component: () => import("@/pages/Machines/Interactions"),
            props: true
          },
          {
            name: "machineEvents",
            path: "events",
            component: () => import("@/pages/Machines/Events"),
            props: true
          },
          {
            name: "machineDevice",
            path: "device",
            component: () => import("@/pages/Machines/MachineDevice"),
            props: true
          },
          {
            name: "machineInventory",
            path: "inventory",
            component: () => import("@/pages/Machines/Inventory"),
            props: true
          },
          {
            name: "machineJournal",
            path: "journal",
            component: () => import("@/pages/Machines/Journal"),
            props: true
          },
          {
            name: "machineStatus",
            path: "status",
            component: () => import("@/pages/Machines/MachineStatus"),
            props: true
          },
          {
            name: "machineLogs",
            path: "logs",
            component: () => import("@/pages/Machines/Logs"),
            props: true
          },
          {
            name: "machineAccess",
            path: "access",
            component: () => import("@/pages/Machines/MachineAccess"),
            props: true
          }
        ]
      },
      {
        path: "devices",
        component: () => import("@/pages/Devices/Devices")
      },
      {
        path: "groups",
        component: () => import("@/pages/Groups/Groups")
      },
      {
        path: "groups/add",
        component: () => import("@/pages/Groups/Add")
      },
      {
        name: "editGroup",
        path: "groups/:id/edit",
        component: () => import("@/pages/Groups/Edit"),
        props: true
      },
      {
        path: "products",
        component: () => import("@/pages/Products/Products")
      },
      {
        path: "products/add",
        component: () => import("@/pages/Products/Add")
      },
      {
        name: "editProduct",
        path: "products/:id/edit",
        component: () => import("@/pages/Products/Edit"),
        props: true
      },
      {
        path: "planograms",
        component: () => import("@/pages/Planograms/Planograms")
      },
      {
        path: "planograms/add",
        component: () => import("@/pages/Planograms/Add")
      },
      {
        name: "editPlanogram",
        path: "planograms/:id/edit",
        component: () => import("@/pages/Planograms/Edit"),
        props: true
      },
      {
        path: "priceLists",
        component: () => import("@/pages/PriceLists/PriceLists")
      },
      {
        path: "priceLists/add",
        component: () => import("@/pages/PriceLists/Add")
      },
      {
        name: "editPriceList",
        path: "priceLists/:id/edit",
        component: () => import("@/pages/PriceLists/Edit"),
        props: true
      },
      {
        path: "attracts",
        component: () => import("@/pages/Attracts/Attracts")
      },
      {
        path: "attracts/add",
        component: () => import("@/pages/Attracts/Add")
      },
      {
        name: "editAttract",
        path: "attracts/:id/edit",
        component: () => import("@/pages/Attracts/Edit"),
        props: true
      },
      {
        path: "status",
        component: () => import("@/pages/Status/Status")
      },
      {
        path: "rmaRequest",
        component: () => import("@/pages/Support/RmaRequest")
      },
       {
        path: "rmaRequest/add",
        component: () => import("@/pages/Support/Add")
      },
      {
        name: "editRmaRequest",
        path: "rma/:id/edit",
        component: () => import("@/pages/Support/Edit"),
        props: true
      },
      {
        name: "viewRmaRequest",
        path: "rma/:id/view",
        component: () => import("@/pages/Support/View"),
        props: true
      },
      {
        name: "viewRmaRequest",
        path: "rmaRequest/:id/view",
        component: () => import("@/pages/Support/Edit"),
        props: true
      },
      {
        path: "dispenseEvents",
        component: () => import("@/pages/DispenseEvents/BinDispense")
      },
      {
        path: "users",
        component: () => import("@/pages/Users/Users")
      },
      {
        name: "addUser",
        path: "users/add",
        component: () => import("@/pages/Users/Add")
      },
      {
        name: "user",
        path: "users/:id",
        props: true,
        component: () => import("@/pages/Users/User"),
        children: [
          {
            name: "userInfo",
            path: "",
            component: () => import("@/pages/Users/UserInfo"),
            props: true
          },
          {
            name: "permissions",
            path: "permissions",
            component: () => import("@/pages/Users/Permissions"),
            props: true
          },
          {
            name: "rfidTag",
            path: "rfidTag",
            component: () => import("@/pages/Users/RfidTag"),
            props: true
          },
          {
            name: "notifications",
            path: "notifications",
            component: () => import("@/pages/Users/Notifications"),
            props: true
          },
          {
            name: "password",
            path: "password",
            component: () => import("@/pages/Users/Password"),
            props: true
          }
        ]
      },
      {
        name: "transactionsReport",
        path: "reports/transactions",
        component: () => import("@/pages/Reports/Transactions")
      },
      {
        name: "deviceTransactionsReport",
        path: "reports/devicetransactions",
        component: () => import("@/pages/Reports/DeviceTransactions")
      },
      {
        name: "serviceForecastReport",
        path: "reports/serviceforecast",
        component: () => import("@/pages/Reports/ServiceForecast")
      },
      {
        name: "bulkUpdatesReport",
        path: "reports/bulkupdates",
        component: () => import("@/pages/Reports/BulkUpdates")
      },
      {
        name: "eventsReport",
        path: "reports/events",
        component: () => import("@/pages/Reports/Events")
      },
      {
        name: "cashUpdateReport",
        path: "reports/cashupdates",
        component: () => import("@/pages/Reports/CashUpdate")
      },
      {
        name: "deviceInteractionsReport",
        path: "/reports/deviceinteractions",
        component: () => import("@/pages/Reports/DeviceInteractions")
      },
      {
        name: "weeklySales",
        path: "reports/weeklysales",
        component: () => import("@/pages/Reports/WeeklySales")
      },
      {
        name: "RfidTags",
        path: "reports/Rfidtags",
        component: () => import("@/pages/Reports/RfidTags")
      },
      {
        path: "/error",
        component: ErrorPage
      }
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory("/"),
  routes
});

router.afterEach((to, from) => {
  const splashScreen = document.querySelector(".app-splash-screen");
  if (splashScreen) {
    splashScreen.style.opacity = 0;
    setTimeout(() => {
      splashScreen?.parentNode?.removeChild(splashScreen);
    }, 300);
  }

  if (
    window.layoutHelpers?.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }

  const instance = getCurrentInstance();
  const appInsights = instance?.proxy?.$appInsights; // Access $appInsights

  if (appInsights) {
    appInsights.trackPageView();
  }

  globals().scrollTop(0, 0);
});

router.beforeEach((to, from, next) => {
  document.body.classList.add("app-loading");

  if (to.matched.some(record => record.meta.noAuthRequired)) {
    next();
  } else {
    setTimeout(() => {
      authGuard(to, from, next);
    }, 10);
  }
});

export default router;
